module.exports = __webpack_public_path__ + "static/media/pmi_cert_small.86a1ad15.png";